<div class="user-codes-container">
  @if(userCodes().length === 0){
  <p class="text-center">Obecnie nie posiadasz żadnych kodów</p>
  } @if(userCodes().length === 0 && errorMessage !== ''){
  <p class="text-center">{{ errorMessage }}</p>
  } @for (code of userCodes(); track code.id) {
  <div class="code">
    <div class="code-info">
      <span class="brand-name">{{ code?.product?.brandName }}</span>
      <!-- <img
        class="brand-logo"
        [src]="code?.product?.images?.[0]?.url ?? ''"
        [alt]="code?.product?.brandName"
      /> -->
      <p class="product-name">{{ code?.product?.name }}</p>
    </div>

    <div class="price-change-container">
      @if ([CodeStatus.started, CodeStatus.back, CodeStatus.withdrawn,
      CodeStatus.return].includes(code.status)) {
      <span
        class="pi pi-minus price-minus-button"
        (click)="onMinusClick(code, $event)"
        (pointerdown)="startHold(code, 'dec', $event)"
        (pointerup)="stopHold()"
        (pointerleave)="stopHold()"
        (pointercancel)="stopHold()"
      ></span>
      }

      <div
        class="price-change mb-1"
        [ngStyle]="{
          'justify-content': [
            CodeStatus.started,
            CodeStatus.back,
            CodeStatus.withdrawn,
            CodeStatus.return
          ].includes(code.status)
            ? 'space-between'
            : 'center'
        }"
      >
        <span class="flip-price"> {{ code.flipPrice | priceFormat }} zł</span>

        <span class="price-diff">
          Prowizja: {{ absDiff(code) | priceFormat }} zł
        </span>
      </div>

      @if ([CodeStatus.started, CodeStatus.back, CodeStatus.withdrawn,
      CodeStatus.return].includes(code.status)) {
      <span
        class="pi pi-plus price-plus-button"
        (click)="onPlusClick(code, $event)"
        (pointerdown)="startHold(code, 'inc', $event)"
        (pointerup)="stopHold()"
        (pointerleave)="stopHold()"
        (pointercancel)="stopHold()"
      ></span>
      }
    </div>

    <div class="timer">
      <app-user-code-timer
        [secondsLeft]="code.mainTimer"
        [startTimerFlag]="
         ((code.status !== CodeStatus.reservation && code.mainTimer < 3600) && (code.status !== CodeStatus.withdrawn && code.mainTimer < 3600))
        "
        [fromUserCodePages]="true"
      ></app-user-code-timer>
    </div>
    @if ([CodeStatus.started, CodeStatus.back,
    CodeStatus.withdrawn].includes(code.status)) {
    <div class="publish-container">
      <button
        class="publish-button"
        aria-label="Publikuj"
        (click)="publish(code)"
      >
        Publikuj
      </button>
    </div>
    } @if ([CodeStatus.reservation].includes(code.status)) {
    <div class="publish-container">
      <button class="publish-button green" aria-label="Rezerwacja">
        Rezerwacja
      </button>
    </div>
    } @if ([CodeStatus.pending, CodeStatus.on_reel].includes(code.status)) {
    <div class="publish-container">
      <button
        class="publish-button yellow"
        aria-label="Cofnij"
        (click)="withdraw(code)"
      >
        Cofnij
      </button>
    </div>
    }
  </div>
  }
</div>
